<template>
	<div id="physmap">
		<GmapMap
		ref="physicianMap"
		:center="default_center"
		:zoom="default_zoom"
		:options="mapOptions"
		map-type-id="roadmap"
		style="width: 100%; height:100%;" />
	</div>
</template>


<script>
	import { mapState } from 'vuex';

	export default {
		
		props: [
			'locations',
			'selectedLocations',
			'default_latitude',
			'default_longitude',
			'searchingWithinMap',
			'visualization_is_on'
		],

		data() {
			return {
				mapPromiseResolved: false,

				mapOptions: {
					disableDefaultUI : true,
					streetViewControl: null,
					zoomControl: null,
					rotateControl: true,
				},

				default_center: {
					lat: parseFloat(this.default_latitude),
					lng: parseFloat(this.default_longitude)
				},
				default_zoom: 10,
				default_search_radius_miles: 10,
				radiusOptions: {},
				metersPerMile: 1609.34,
				markers: [],
				boundsListener: null,
				clickListenerForRadiusCircle: null,
				radiusCircle: null,
				icon: { //base icon styling
				    path: 'M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z',
				    fillColor: '#EE2742',
				    fillOpacity: 1,
				    strokeWeight: 1.25,
				    strokeColor: 'rgba(255,255,255,.8)',				    
				    size: {width: 24, height: 24, f: 'px', b: 'px'},
				    anchor: {x: 12, y: 24, },
				    scale: 1.5
				},

				iconSelected: { //selected icon styling
				    path: 'M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z',
				    fillColor: '#ffffff',
				    fillOpacity: 1,
				    strokeWeight: 1.25,
				    strokeColor: '#EE2742',				    
				    size: {width: 24, height: 24, f: 'px', b: 'px'},
				    anchor: {x: 12, y: 24, },
				    scale: 1.5
				},
				iconSelectedForRoute: { //selected for route
				    path: 'M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z',
				    fillColor: '#846086',
				    fillOpacity: 1,
				    strokeWeight: 1.25,
				    strokeColor: '#faecfb',				    
				    size: {width: 24, height: 24, f: 'px', b: 'px'},
				    anchor: {x: 12, y: 24, },
				    scale: 1.5
				}
			}
		},

		created() {
			this.visualization_is_on = ((this.visualization_is_on) ? this.visualization_is_on : false);

			let self = this;
			window.goToProvider = function(locationId) {
				self.$router.push({ 
					name: self.locations.find(location => location.id == locationId).locationable_type == 'App\\Group' ? 'groups.show' : 'physicians.show', 
					params: { id: self.locations.find(location => location.id == locationId).locationable_id }
				});
			};

		    window.addLocationToRoute = function(locationId) {
		    	self.$root.$emit('select-location-from-map', locationId);
		    	self.toggleAddToRouteButtons(false);
		    };

		    window.removeLocationFromRoute = function(locationId) {
		    	self.$root.$emit('deselect-location-from-map', locationId);
		    	self.toggleAddToRouteButtons(true);
		    };

		    window.hideLocationFromMaps = function(locationId) {
		    	if (confirm("Hide this specific location from maps? (Note: you can add it back by editing the physician from master list on the left.")) {
		    		
		    		for (var i = 0; i < self.locations.length; i++) {
		    			if (self.locations[i].id == locationId) {
		    				self.locations[i].show_in_maps = false;
		    			}
		    		}

			    	// update map
			    	self.updateMap();

			    	// update server
			    	axios.put('/api/locations/' + locationId + '/toggle_show_in_maps').then((response) => {
			    		Swal.fire({
			    			toast: true,
			    			position: 'top-end',
			    			showConfirmButton: false,
			    			timer: 7000,
			    			icon: 'success',
			    			title: "Now hiding from maps. You can adjust in physician details page.",
			    		});       
			    	});
		    	}

		    }
		}, 


		mounted() {
			//this.newMap();
				this.$refs.physicianMap.$mapPromise.then(() => {
					this.mapPromiseResolved = true;
					this.setMapOptions();
					this.newMap();
				});
			///// The map will work if this kind of thing is stuck in mounted.
			// Map also works on mobile, when it's displayed after loading
			// Something about the promise not being resolved?
			// setTimeout(() => {
   //  			this.updateMap()
   //  		}, 3000);


			this.$root.$on('bounds-changed', (data) => { 
				this.mapBounds = data;
			});		

			this.$root.$on('map-adjust', () => {
				this.updateMap();
		    });

	        this.$root.$on('show-location', (locationId) => {
	    		this.showMarker(locationId);
	        });

		    this.$root.$on('select-location', (locationId) => {
				this.showMarker(locationId);
				this.selectMarker(locationId);
		    });

	        this.$root.$on('deselect-location', (locationId) => {
	    		this.resetMarker(locationId);
	        });
		},


		methods: {
			setMapOptions() {
				if (this.config.layout === 'mobile') {
					this.mapOptions.streetViewControl = false;
					this.mapOptions.zoomControl = false;
				} else {
					this.mapOptions.streetViewControl = true;
					this.mapOptions.zoomControl = true;
				}
			},

			toggleAddToRouteButtons(showAdd = true) {
				var addToRouteButton = document.getElementById("addToRouteButton");
				var removeFromRouteButton = document.getElementById("removeFromRouteButton");
				if (showAdd) {
			    	addToRouteButton.style.display = "block"; 
					removeFromRouteButton.style.display = "none"; 
				} else {
					addToRouteButton.style.display = "none"; 
					removeFromRouteButton.style.display = "block"; 
				}
			}, 

			showMarker(locationId) {
				//let map = this.$refs.physicianMap.$mapPromise;
				let marker = this.markers.find(marker => marker.id == locationId);
				if (typeof marker !== "undefined") {
					google.maps.event.trigger(marker, 'click');					
				}
			},

			selectMarker(locationId) {
				//let map = this.$refs.physicianMap.$mapPromise;
				let marker = this.markers.find(marker => marker.id == locationId);
				if (typeof marker !== "undefined") {
					marker.selected = true;
					google.maps.event.trigger(marker, 'marker_selected');
				}
			},

			resetMarker(locationId) {
				//let map = this.$refs.physicianMap.$mapPromise;
				let marker = this.markers.find(marker => marker.id == locationId);
				if (typeof marker !== "undefined") {
					marker.selected = false;
					google.maps.event.trigger(marker, 'shape_changed');
				}
			},

			removeRadiusCircle() {
				if (this.radiusCircle) {
					this.radiusCircle.setMap(null);
				}
			},

			goToProvider(locationId) {
				this.$router.push({ 
					name: this.locations.find(location => location.id == locationId).locationable_type == 'App\\Group' ? 'groups.show' : 'physicians.show',
					params: { id: this.locations.find(location => location.id == locationId).locationable_id }
				});
			},

			buildHtmlMarkerContent(location) {
				var html = '<div class="font-weight-bold mb-2 text-lg text-capitalize" style="min-width:170px">';
				html += '<a href="#" onclick="goToProvider(' + location.id + ')">' + (location.display_name).toLowerCase() + '</a>';
				html += "</div>";
				html += "<div class='mb-2'>" + location.formatted_address + "</div>";
    			html += (location.email ? '<i class="fas fa-envelope text-muted mr-1"></i><a href="mailto:' + location.email +'">' + location.email + '</a><br>' : '');
    			html += (location.phone ? '<i class="fa fa-phone text-muted mr-1"></i>' + location.phone + '<br>' : '');
    			html += (location.fax ? '<i class="fa fa-fax text-muted mr-1"></i>' + location.fax + '<br>' : '');

    			html += '<div class="d-flex border-top justify-content-between mt-3 pt-3">';
    			// add to route selection
    			html += "<button id='addToRouteButton' style='display:none;' class='btn btn-sm btn-primary' onclick='addLocationToRoute(" + location.id + ");' >Add to Route</button>";

    			html += "<button id='removeFromRouteButton' style='display:none;' class='btn btn-sm btn-light' onclick='removeLocationFromRoute(" + location.id + ");'>Remove from Route</button>";

    			// remove from map
    			html += "<button class='btn btn-sm btn-light text-gray-500' onclick='hideLocationFromMaps(" + location.id + ");' data-toggle='tooltip' title='Hide this location'><i class='far fa-eye-slash'></i></button>";
    			html += "</div>";

				return html;
			},

			newMap() {
				if (this.mapPromiseResolved) {
					this.$refs.physicianMap.$mapPromise.then((map) => {
						//var map = this.$refs.physicianMap.$mapObject;
						var self = this;

						if (this.searchingWithinMap || this.locationsFiltered.length == 0) {
							
							var bounds = map.getBounds(); // get default bounds
							map.setZoom(this.default_zoom);
							map.setCenter(this.default_center);
						} else {
							var bounds = new google.maps.LatLngBounds();
						}

						let infowindow = new google.maps.InfoWindow();
						let allMarkers = this.markers;
						let eventBus = this.$root;

						// let oms = new OverlappingMarkerSpiderfier(map, {
						//   markersWontMove: true,
						//   markersWontHide: false,
						//   basicFormatEvents: true
						// });	

						if (!self.boundsListener) {
							self.boundsListener = map.addListener('idle', function() { 
								var bounds = map.getBounds();
								eventBus.$emit('bounds-changed', bounds);
							});
						}

						if (!self.clickListenerForRadiusCircle) {
							self.clickListenerForRadiusCircle = map.addListener('click', function(event) { 
							
								self.removeRadiusCircle();

								if (!self.searchingWithinMap) {
									return;
								}

								var latitude = event.latLng.lat();
							    var longitude = event.latLng.lng();
							    var miles = self.default_search_radius_miles;
							    self.radiusCircle = new google.maps.Circle({map: map,
							    	radius: miles * self.metersPerMile, // in meters. 1609.34 meters/mile
							    	center: event.latLng,
							    	fillColor: '#777',
							    	fillOpacity: 0.1,
							    	strokeColor: '#AA0000',
							    	strokeOpacity: 0.8,
							    	strokeWeight: 2,
						            draggable: true,    // Dragable
						            editable: true      // Resizable
						        });

						        // Center of map
						        map.panTo(new google.maps.LatLng(latitude,longitude));

						        // set and send radius options to other components for filtering
						        self.radiusOptions = {
						        	latitude: latitude,
						        	longitude: longitude, 
						        	miles: miles
						        };
								eventBus.$emit('search-within-map-radius-changed', self.radiusOptions);

								// listen for radius change
								self.radiusCircle.addListener('radius_changed', function() {
								  	self.radiusOptions.miles = self.radiusCircle.getRadius() / self.metersPerMile;
								  	eventBus.$emit('search-within-map-radius-changed', self.radiusOptions);

								  	// let boundsCircle = self.radiusCircle.getBounds();
								  	// map.fitBounds(boundsCircle);
								});

								// listen for moving the circle
								self.radiusCircle.addListener('dragend', function(event) {
									self.radiusOptions.latitude = self.radiusCircle.getCenter().lat();
									self.radiusOptions.longitude = self.radiusCircle.getCenter().lng();
									eventBus.$emit('search-within-map-radius-changed', self.radiusOptions);

								  	// let boundsCircle = self.radiusCircle.getBounds();
								  	// map.fitBounds(boundsCircle);
								});


							});
						}
						
						this.locationsFiltered.forEach(location => {
							var physicianIcon = {...this.icon};
							let iconSelected = {...this.iconSelected};
							let iconSelectedForRoute = {...this.iconSelectedForRoute};

							//set the color if defined; otherwise default
							if (this.visualization_is_on && location.iconFillColor) {
						    	physicianIcon.fillColor = location.iconFillColor;
						    } else {
						    	physicianIcon.fillColor = this.icon.fillColor;
						    }

						    if (this.locationIdSelectedForRoute(location.id)) {
						    	physicianIcon = iconSelectedForRoute;			    					    	
						    }

						    let iconRestored = physicianIcon;

						    let marker = new google.maps.Marker({
						    	position: {
							      lat: parseFloat(location.markers.position.lat),
							      lng: parseFloat(location.markers.position.lng),
							    },
						    	icon: physicianIcon,
						    	map: map,
						    	infowindow: infowindow,
						    	id: location.id,
						    	selected: false,
						    });
						    var currentMarker;

						    if (!this.searchingWithinMap) {
						    	bounds.extend(marker.position);
						    }

						    allMarkers.push(marker);

			    	    	//oms.trackMarker(marker);

			    	    	var self = this;
			    	    	
			    	    	// show marker
			    	    	google.maps.event.addListener(marker, 'click', function() {
			    	    		this.infowindow.close(); // just in case another is open
			    	    		infowindow.setContent(self.buildHtmlMarkerContent(location));
			    	    		this.infowindow.open(map, this);
			    	    		marker.setIcon(iconSelected);
			    	    		currentMarker = this;
			    	    		//self.toggleAddToRouteButtons(true);
			    	    		setTimeout(() => {
			    	    			if (self.locationIdSelectedForRoute(location.id)) {
			    	    				self.toggleAddToRouteButtons(false); 
			    	    			} else {
			    	    				self.toggleAddToRouteButtons(true); 
			    	    			}
			    	    		}, 100);
			    		    	//oms.trackMarker(marker);
			    		    });

			    	    	// infowindow close button clicked - reset marker
			    		    google.maps.event.addListener(infowindow, 'closeclick', function() {
			    		    	if (typeof currentMarker !== "undefined") {
			    		    		if (currentMarker.selected) {
			    		    			currentMarker.setIcon(iconSelectedForRoute);
			    		    		} else {
			    		    			currentMarker.setIcon(iconRestored);		    	    			
			    		    		}
			    		    	}		    		    	
			    		    });

			    	    	// select marker
			    	    	google.maps.event.addListener(marker, 'marker_selected', function() {
			    	    		marker.setIcon(iconSelectedForRoute);
			    	    	});

			    	    	// reset marker
			    	    	google.maps.event.addListener(marker, 'shape_changed', function() {
			    	    		if (marker.selected) {
			    	    			marker.setIcon(iconSelectedForRoute);
			    	    		} else {
			    	    			marker.setIcon(iconRestored);		    	    			
			    	    		}
			    	    		this.infowindow.close();
			    	    	});
						});

						if (!this.searchingWithinMap) {
							map.fitBounds(bounds);
						}

					})	
				}
			},	

			updateMap() {
				Vue.nextTick( () => {
					if (this.locationsFiltered == null) {
						return;
					} 

					//let map = this.$refs.physicianMap.$mapPromise;
					let allMarkers = this.markers;
					
					//clear markers and dump the marker array
					allMarkers.forEach(marker => { marker.setMap(null); });
					allMarkers.length = 0; 
					//rebuild new map
					this.newMap();
				});
			},

			updateMarker() {

			},

			locationIdSelectedForRoute(locationId) {
				return this.selectedLocations.some(location => location.id == locationId);
			}
		},

		computed: {
			...mapState(['config']),

			locationsFiltered() {
				return _.filter(this.locations, { 'show_in_maps': 1 });
			}
		},

		watch: {
			config: {
				handler() {
					this.setMapOptions();
				},
				deep: true,
			},

			// mapPromiseResolved() {
			// 	this.updateMap();
			// },

			locations() {
				this.updateMap();
			},

			searchingWithinMap() {
				this.removeRadiusCircle();
				this.updateMap();
			},
		}
	}


</script>

<style>
	#physmap { 
		min-height: 200px;
		height: 100%;
		width: 100%;
		flex:1; 
	}

</style>